import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IconSizeEnum, SdIconComponent } from '@seb/web-design-system/core';

import type { IDividedPayment } from './divided-payment.interface';

@Component({
  selector: 'sd-divided-payment',
  templateUrl: './divided-payment.component.html',
  styleUrls: ['./divided-payment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdIconComponent, TranslateModule]
})
export class SdDividedPaymentComponent {
  iconSizeEnum = IconSizeEnum;

  @Input()
  dividedData: IDividedPayment;

  @Output()
  dividedClick: EventEmitter<void> = new EventEmitter();

  onDividedClick() {
    this.dividedClick.emit();
  }
}
